import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("orv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function formatDetail(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((entry) => (entry && typeof entry.msg === "string" ? entry.msg : ""))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "";
}

export function formatApiError(error, fallback = "Unexpected server error. Please try again.") {
  const response = error?.response;
  const data = response?.data;

  if (typeof data?.message === "string" && data.message.trim()) return data.message;
  const detailMessage = formatDetail(data?.detail);
  if (detailMessage) return detailMessage;

  if (!response) {
    if (error?.code === "ECONNABORTED") return "The request timed out. Please try again.";
    return "Unable to reach the server. Please check your connection and try again.";
  }

  if (response.status >= 500) return fallback;
  return fallback;
}

export default api;
